import { Link } from "react-router-dom";
import styles from "./ThankYou.module.css";
import { useIntl } from "react-intl";

const ThankYou = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.contentCard}>
        <div className={styles.iconContainer}>
          <div className={styles.checkIcon}>✓</div>
        </div>

        <h1 className={styles.title}>
          {intl.formatMessage({ id: "thankYouId1" })}
        </h1>
        <p className={styles.message}>
          {intl.formatMessage({ id: "thankYouId2" })}
        </p>

        <div className={styles.actions}>
          {/* <Link to="/" className={styles.primaryButton}>
            Access Your Dashboard
          </Link> */}
          <Link to="/signin" className={styles.secondaryButton}>
            {intl.formatMessage({ id: "thankYouId3" })}
          </Link>
        </div>

        <div className={styles.footer}>
          <p className={styles.footerText}>
            {intl.formatMessage({ id: "thankYouId4" })}
            <a href="#" className={styles.supportLink}>
              {intl.formatMessage({ id: "thankYouId5" })}
            </a>
          </p>
        </div>
      </div>

      <div className={styles.backgroundDecoration}>
        <div className={styles.shape1}></div>
        <div className={styles.shape2}></div>
        <div className={styles.shape3}></div>
      </div>
    </div>
  );
};

export default ThankYou;
